import React from 'react';
import { Section, SectionHeading } from '../Section';
import { CtaButton } from '../CtaButton';
const items = [{
  icon: '🦷',
  title: '“I have a complex case… where do I even start?”',
  body: 'The patient presents with severe wear, loss of structure or extensive restorative needs, and you need a clear way to organize the case.'
}, {
  icon: '🤯',
  title: '“I know the theory… but applying it is different.”',
  body: 'You understand the concepts, but bringing all the variables together in a real patient can feel overwhelming.'
}, {
  icon: '📐',
  title: '“I’m still second-guessing my VDO decisions.”',
  body: 'You want to evaluate the relevant factors systematically rather than relying on one isolated measurement or intuition.'
}, {
  icon: '🔍',
  title: '“What if I’m missing something?”',
  body: 'Complex cases contain multiple variables. Without a process, important questions can easily get overlooked.'
}, {
  icon: '⏱️',
  title: '“I keep going back to my notes.”',
  body: 'Books, lectures, saved posts and old course materials are scattered everywhere.'
}, {
  icon: '💰',
  title: '“I know I could take on more complex cases.”',
  body: 'But uncertainty can make you hesitate before committing to them.'
}];
export function SoundsFamiliar() {
  return <Section tone="dark" data-id="element-278" data-mp="25ya0lj3891r0">
      <SectionHeading eyebrow="Be honest" title="Does this sound familiar?" data-id="element-279" data-mp="29ykfjl8zz2i0" />

      <div className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-280" data-mp="2a0n37ymogjjk">
        {items.map(item => <article key={item.title} className="flex h-full flex-col rounded-2xl border border-white/10 bg-navy-950 p-5" data-id="element-281" data-mp="2evsqp1vqa69r">
            <span className="text-2xl" aria-hidden="true" data-id="element-282" data-mp="2ow334k9xv9nv">
              {item.icon}
            </span>
            <h3 className="mt-3 font-display text-[17px] font-bold leading-snug text-white sm:text-xl" data-id="element-283" data-mp="pjh1bs7r5ovn">
              {item.title}
            </h3>
            <p className="mt-2 text-[15px] leading-relaxed text-slate-300" data-id="element-284" data-mp="ujwhssnbzchu">{item.body}</p>
          </article>)}
      </div>

      <div className="mx-auto mt-10 max-w-2xl rounded-2xl border border-gold-500/30 bg-navy-950 p-5 text-center sm:p-7" data-id="element-285" data-mp="hi9jchl4iapq">
        <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-gold-500" data-id="element-286" data-mp="wgblcnciao4v">
          If you said yes to even one of these…
        </p>
        <p className="mt-3 text-[15px] leading-relaxed text-slate-200 sm:text-lg" data-id="element-287" data-mp="rijuzxrifa2s">
          You’re not necessarily missing more information. You may simply need a better system for
          organizing the information you already have.
        </p>
      </div>

      <div className="mt-8 flex justify-center" data-id="element-288" data-mp="1f4gllktyfqyx">
        <CtaButton label="Get the Oclusion Clinical Playbook™" subLabel="$27 one-time · Instant digital access" data-id="element-289" data-mp="1a6os4mdnvwsm" />
      </div>
    </Section>;
}